const defaultRequestOptions = {
  formTemplate: {
    include_form_template_fields: true,
  },
}

export default defaultRequestOptions
